import { ComponentIds, Entity, RoomPartComponent } from '@inter-ikea-core/core';

type RoomPartEntityIdsByComponentTypeName = Partial<Record<string, Set<number>>>;

/**
 * Extracts room part entity ids from an array of room part entities and groups them by their component type names
 *
 * @param roomParts - Array of room part entities
 * @returns sets of the room part entity ids grouped in an object keyed by their component type names
 */
export const extractRoomPartEntityIdsByComponentTypeName = (roomParts: Entity[]) =>
  roomParts.reduce<RoomPartEntityIdsByComponentTypeName>((acc, roomPartEntity) => {
    const roomPartComponent = roomPartEntity?.getComponent<RoomPartComponent>(
      ComponentIds.ROOM_PART_COMPONENT_ID
    );
    if (!roomPartEntity || !roomPartComponent) {
      return acc;
    }
    const roomPartTypeName = roomPartComponent.typeName;
    if (!acc[roomPartTypeName]) {
      acc[roomPartTypeName] = new Set<number>();
    }
    acc[roomPartTypeName].add(roomPartEntity.id);
    return acc;
  }, {});
